const LOCAL_STORAGE_RECENTLY_VIEWED_KEY = 'shopify-recently-viewed';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const RECENTLY_VIEWED_MAX = 4;

const selectors = {
  grid: '[grid-recently-viewed]',
  productCard: '[product-card]',
};

document.addEventListener('DOMContentLoaded', () => {
  initGrid();
});

document.addEventListener('shopify-recently-viewed:init-product-grid', (event) => {
  console.log('[Shopify Recent] Product Grid Loaded ✅', event.detail.products);
});



const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;

  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Recently Viewed] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const recentlyViewed = getRecentlyViewed();
  const requests = recentlyViewed.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  
  grid.innerHTML = responses.join('');
  grid.classList.add(GRID_LOADED_CLASS);

  const event = new CustomEvent('shopify-recently-viewed:init-product-grid', {
    detail: { products: recentlyViewed }
  });
  document.dispatchEvent(event);
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const getRecentlyViewed = () => {
  const recentlyViewed = localStorage.getItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY) || false;
  if (recentlyViewed) return recentlyViewed.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setRecentlyViewed = (array) => {
  const recentlyViewed = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY, recentlyViewed);
  else localStorage.removeItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY);

  return recentlyViewed;
};

const addToRecentlyViewed = (handle) => {
  console.log("addToRecentlyViewed() called");
  const recent = getRecentlyViewed();
  var indexInHistory = recent.indexOf(handle);
  while (indexInHistory !== -1) {
    recent.splice(indexInHistory, 1); // remove old copies
    indexInHistory = recent.indexOf(handle);
  }
  recent.push(handle);
  console.log(recent);
  return setRecentlyViewed(recent.slice(-RECENTLY_VIEWED_MAX));
};

const recentlyViewedContains = (handle) => {
  const recent = getRecentlyViewed();
  return recent.includes(handle);
};

const resetHistory = () => {
  return setRecentlyViewed([]);
};